import { toast } from "sonner";
import { cn } from "@/lib/utils";
import { getWhatsAppLink } from "@/lib/config";

const variants = {
  primary:
    "bg-navy text-cream hover:bg-navy-dark hover:shadow-[0_10px_30px_-8px_rgba(15,27,61,0.45)] border border-transparent hover:ring-2 hover:ring-gold/60",
  gold:
    "bg-gold text-navy hover:bg-soft-gold hover:shadow-[0_10px_30px_-8px_rgba(201,168,76,0.55)] border border-transparent font-semibold",
  outline:
    "bg-transparent text-navy border border-navy/25 hover:border-navy/60 hover:bg-navy/[0.04]",
  outlineLight:
    "bg-transparent text-cream border border-cream/30 hover:border-gold hover:text-gold",
};

export function CtaButton({
  variant = "primary",
  scrollTo,
  className,
  children,
  testId,
  ...rest
}) {
  const handleClick = (e) => {
    if (scrollTo) {
      e.preventDefault();
      document.getElementById(scrollTo)?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    const link = getWhatsAppLink();
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    } else {
      toast.success("WhatsApp onboarding is launching soon", {
        description: "We'll share the number shortly — thank you for your interest in ShubhSamay.",
      });
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={handleClick}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm sm:text-base font-medium transition-all duration-300 ease-out active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-cream",
        variants[variant],
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
